export default {
  brand: "USFansLink",
  nav_spreadsheet: "Spreadsheet",
  nav_guides: "Guides",
  nav_reviews: "Reviews",
  nav_shipping: "Shipping",
  nav_coupon: "Coupon",
  nav_warehouse: "Warehouse",
  nav_safety: "Safety",
  nav_faq: "FAQ",
  nav_home: "Home",
  nav_shopping_guide: "Shopping Guide",
  explore_main: "Explore Main Site",
  back_home: "Back to Home",
  read_more: "Read more",
  visit_main: "Visit Main Website",
  independent_note: "Independent informational resource · Not officially affiliated with USFans",
  language_label: "Language",
  // Categories
  cat_shoes: "Shoes",
  cat_hoodies: "Hoodies / Sweaters",
  cat_tshirts: "T-Shirts",
  cat_jackets: "Jackets",
  cat_pants: "Pants / Shorts",
  cat_headwear: "Headwear",
  cat_sets: "Sets",
  cat_underwear: "Underwear / Underpants",
  cat_jersey: "Jersey",
  cat_accessories: "Accessories",
  cat_bags: "Bags",
  cat_belts: "Belts",
  cat_perfumes: "Perfumes",
  cat_other: "Other Stuff",
  // Footer
  footer_resources: "Resources",
  footer_company: "Company",
  footer_links: "Quick Links",
  footer_about: "About",
  footer_contact: "Contact",
  footer_editorial: "Editorial Policy",
  footer_updates: "Updates",
  footer_disclaimer: "Disclaimer",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms",
  footer_rights: "All rights reserved.",
  footer_tagline: "An independent hub for USFans spreadsheet resources, guides and safety information.",
};